<template>
    <div class="row">
        <div class="col">
            <search></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from './statements/Result'
    import Search from './statements/Search'

    export default {
    
        components: {
            Search, Result
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$xapi.filters.context.loadOptions().then(() => {
                next()
            })
        }
    }
</script>
